import { render, staticRenderFns } from "./MobileAppReminderModal.vue?vue&type=template&id=5034d946&scoped=true&"
import script from "./MobileAppReminderModal.vue?vue&type=script&lang=ts&"
export * from "./MobileAppReminderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5034d946",
  null
  
)

export default component.exports